/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

import HeaderBarCellView from './HeaderBarCellView';
import tmplHeaderBarCustomerDetailsCellView from './HeaderBarCustomerDetailsCellView.hbs';

const HeaderBarCustomerDetailsCellView = HeaderBarCellView.extend({
  template: tmplHeaderBarCustomerDetailsCellView,

  className: 'header-bar-cell-view header-bar-customer-details-cell-view',

  onBeforeRender() {
    const pocName = this.model.get('customerDetails')?.firstName?.concat(' ', this.model.get('customerDetails')?.lastName);
    const pocEmail = this.model.get('customerDetails')?.email;
    const pocTelephone = this.model.get('customerDetails')?.telephone;

    this.model.set('pocName', pocName);
    this.model.set('pocEmail', pocEmail);
    this.model.set('pocPhone', pocTelephone);
  }
});

export default HeaderBarCustomerDetailsCellView;
